export default __webpack_public_path__ + "static/media/p6.d32ac194.jpg";